import { Store } from 'src/store/index';

const getBackUrl = (store: Store) => store.app.backUrl;

export default getBackUrl;
